/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

const styles = theme => ({
  hide: {
    display: 'none',
  },
  arabicLanguage: {
    direction: 'rtl',
  },
  titleHead: {
    background: '#F8F8F8',
    color: '#342D3D',
    display: 'flex',
    alignItems: 'center',
    padding: '10px 16px',
    [theme.breakpoints.up('md')]: {
      borderBottom: '1px solid #CED1D6',
    },
    '& h1': {
      marginBottom: '0',
      marginRight: '8px',
      fontSize: '16px',
      // '& span': {
      //   color: '#D2374F',
      // },
    },
    '& $textGray': {
      color: '#8C9099',
      fontSize: '14px',
      alignSelf: 'flex-end',
    },
  },
  fileNameWrapper: {
    '& img': {
      width: '25px',
      [theme.breakpoints.down('md')]: {
        width: '20px',
      },
    },
  },
  fileName: {
    fontSize: '1rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    },
  },
  appendixAlertInfo: {
    width: '100%',
    marginBottom: '10px',
  },
  textGray: {},
  Title: {
    fontWeight: '600',
    marginBottom: '5px',
  },
  strongText: {
    fontSize: '18px',
    fontWeight: '600',
  },
  textADGMPrimary: {
    color: '#D2374F',
  },
  initiateserviceSect: {
    marginBottom: '16px',
  },
  initiateservicedtaile: {
    display: 'grid',
    gridTemplateColumns: '61px auto',
    gap: '9px',
  },
  paperCardFrame: {
    marginBottom: '24px',
    borderRadius: '0px',
    overflow: 'hidden',
  },
  innerCardGrid: {
    padding: '16px',
  },
  horizontalradio: {
    flexDirection: 'row',
    color: '#190B28',
    '& input:checked + div': {
      color: theme.palette.primary.main,
    },
    '& svg': {
      height: '28px',
      width: '28px',
    },
  },
  formControl: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: '16px',
  },
  unitinputControl: {
    '& > p': {
      display: 'block',
      marginBottom: '9px',
      fontWeight: '500',
      '& span': {
        // color: '#D2374F',
        fontSize: '18px',
      },
    },
    '& input': {
      padding: '17px 16px',
      '&:valid:focus + fieldset': {
        borderColor: '#342D3D',
        borderWidth: '1px',
      },
    },
    '& fieldset': {
      border: '1px solid #CED1D6',
      borderRadius: '10px',
    },
  },
  addoccpantsBtn: {
    height: '36px',
    minWidth: '167px',
    fontSize: '12px',
    fontWeight: '600',
    textTransform: 'none',
    border: '1.36111px solid #342D3D',
    borderRadius: '10px',
    '& img': {
      marginRight: '4px',
      width: '12px',
    },
  },
  uplaodbtnHolder: {
    '& input': {
      display: 'none',
    },
  },
  appendixDetailItem: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: '32px 0',
    borderBottom: '1px solid #EBEEF3',
    marginBottom: '18px',
    '& img': {
      width: '24px',
      marginRight: '12px',
      [theme.breakpoints.down('md')]: {
        width: '22px',
      },
    },
    '&:first-child': {
      padding: '0 0 32px',
    },
    '& p': {
      '& img': {
        marginRight: '17px',
      },
    },
    '& $removeLink': {
      marginLeft: 'auto',
      color: '#8C9099',
      flexShrink: '0',
    },
  },
  removeLink: {},
  largeButton: {
    height: '36px',
    minWidth: '167px',
    fontSize: '12px',
    fontWeight: '600',
    textTransform: 'none',
    border: '1.36111px solid #342D3D',
    borderRadius: '10px',
    '& img': {
      marginRight: '4px',
      width: '12px',
    },
  },
  fileContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '18px 0px',
    borderBottom: `1px solid ${theme.palette.primary.borderColor}`,
    // marginBottom: '1.125em',
    '& p': {
      fontSize: '12px',
    },
    '& img': {
      marginRight: '12px',
    },
    '& button': {
      marginLeft: 'auto',
      textTransform: 'none',
      color: 'grey',
      flexShrink: '0',
      // fontSize: '12px',
    },
    '& $btnHolder': {
      marginLeft: 'auto',
      '& > span': {
        color: theme.palette.primary.darkGrey,
      },
    },
  },
  modalpaper: {
    position: 'absolute',
    width: '50%',
    backgroundColor: '#fff',
    padding: '24px',
    borderRadius: '10px',
    fontSize: '16px',
  },
  modal: {
    width: '100%',
    maxWidth: '747px',
    margin: '20px auto',
    position: 'relative',
    '& $Title': {
      marginBottom: '32px',
    },
    '& $crossIconimg': {
      position: 'absolute',
      right: '24px',
      top: '31px',
    },
    '& $unitinputControl': {
      '& > p': {
        display: 'block',
        marginBottom: '9px',
        fontWeight: '500',
        '& span': {
          // color: '#D2374F',
          fontSize: '18px',
        },
      },
      '& textarea': {
        padding: '21px 16px',
        width: '100%',
        border: '1px solid #CED1D6',
        borderRadius: '10px',
        minHeight: '160px',
        fontSize: '16px',
      },
      '& fieldset': {
        border: '1px solid #CED1D6',
        borderRadius: '10px',
      },
    },
    '& $formControl': {
      gridTemplateColumns: '1fr',
    },
    '& $modaltitlehead': {
      display: 'block',
      '& img': {
        display: 'none',
      },
    },
  },
  modaltitlehead: {},
  crossIconimg: {},
  submitBtnholder: {
    textAlign: 'right',
    padding: '8px 0 0',
  },
  submitBtn: {
    background: theme.palette.primary.main,
    fontSize: '16px',
    color: '#fff',
    height: '60px',
    minWidth: '151px',
    textTransform: 'none',
    borderRadius: '10px',
  },
  acceptTCmodal: {
    maxWidth: '463px',
    '& h3': {
      marginBottom: '28px',
      color: '#342D3D',
      fontSize: '16px',
      fontWeight: '500',
    },
    '& hr': {
      backgroundColor: '#CED1D6',
    },
    '& $acceptSubTitle': {
      fontWeight: '400',
      fontSize: '18px',
      color: '#0496FF',
    },
  },
  separator: {
    margin: '0 10px',
  },
  acceptSubTitle: {},
  checkboxHolder: {
    paddingTop: '20px',
    '& $btnholder': {},
  },
  acceptcheckboxLabel: {
    marginBottom: '20px',
    color: '#342D3D',
    padding: '0 5px 0 0',
    alignItems: 'flex-start',
    '& span': {
      color: '#342D3D',
      paddingTop: '0',
    },
    '& input:checked + svg': {
      color: '#1FCACC',
    },
  },
  btnsDefult: {
    borderRadius: '10px',
    fontSize: '16px',
    fontWeight: '600',
    height: '48px',
    background: '#CED1D6',
    color: '#8C9099',
  },
  btnProceedpayment: {
    background: theme.palette.primary.main,
    color: '#fff',
    display: 'block',
    width: '100%',
    textTransform: 'none',
    '&:hover': {
      background: '#a9263a',
    },
  },
  btnholder: {},
  accordionSummary: {
    borderBottom: `1px solid ${theme.palette.primary.borderColor}`,
    padding: '16px 24px',
  },
  accordionTitle: {
    '& img': {
      marginRight: '10px',
    },
  },
  '@media (min-width: 768px)': {
    titleHead: {
      padding: '16px 24px',
      '& h1': {
        fontSize: '20px',
      },
    },
    innerCardGrid: {
      padding: '24px',
      paddingTop: 0,
    },
    addoccpantsBtn: {
      height: '60px',
      minWidth: '228px',
      fontSize: '16px',
      borderRadius: '13.6111px',
      '& img': {
        marginRight: '8px',
        width: '17px',
      },
    },
  },
  '@media (min-width: 992px)': {
    // contentArea: {
    //   paddingLeft: '50px',
    // },
    formControl: {
      gridTemplateColumns: '1fr 1fr',
    },
  },
  '@media (max-width: 767px)': {
    buttonMargin: {
      marginTop: 24,
    },
    titleHead: {
      flexWrap: 'wrap',
    },
    paperCardFrame: {
      border: '0',
      borderRadius: '0',
    },
    appendixmodal: {
      top: '0',
      left: '0',
      transform: 'translate(0)',
      maxWidth: '100%',
      borderRadius: '0',
      height: '100%',
      '& $Title': {
        fontSize: '16px',
        marginBottom: '0',
      },
      '& $crossIconimg': {
        display: 'none',
      },
      '& $modaltitlehead': {
        display: 'flex',
        alignItems: 'center',
        paddingBottom: '16px',
        borderBottom: '3px solid #EBEEF3',
        marginBottom: '10px',
        '& img': {
          marginRight: '13px',
          display: 'inline-block',
        },
      },
    },
    acceptTCmodal: {
      width: '90%',
      '& $Title': {
        fontSize: '16px',
        marginBottom: '20px',
      },
      '& $acceptSubTitle': {
        fontSize: '14px',
        marginBottom: '16px',
      },
      '& $acceptcheckboxLabel': {
        alignItems: 'center',
        '& span': {
          fontSize: '12px',
        },
      },
    },
    submitBtnholder: {
      position: 'fixed',
      bottom: '0',
      left: '0',
      right: '0',
      background: '#fff',
      padding: '16px',
      borderTop: '3px solid #EBEEF3',
      zIndex: '1021',
      '& button': {
        width: '100%',
        margin: '0',
        height: '48px',
      },
    },
  },
  '@media (max-width: 960px)': {
    buttonMargin: {
      marginTop: 24,
    },
  },
  linkBtn: {
    fontSize: '14px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    },
  },
});

export default styles;
